import { render, staticRenderFns } from "./SeparationFactSheet.vue?vue&type=template&id=dbcd2542&scoped=true"
import script from "./SeparationFactSheet.vue?vue&type=script&lang=js"
export * from "./SeparationFactSheet.vue?vue&type=script&lang=js"
import style0 from "./SeparationFactSheet.vue?vue&type=style&index=0&id=dbcd2542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcd2542",
  null
  
)

export default component.exports